import {isWeChatBrowser} from "../core/utils";

export default {
    WECHAT_BROWSER: isWeChatBrowser(),
}